export default __webpack_public_path__ + "static/media/pantalon-bombero-hombre.1d953060.png";